import {Component, OnInit} from '@angular/core';
import {environment} from "../../../environments/environment";
import {NAVER_CALLBACK_SIGN} from "../../shared/defines/protocol";
import * as $ from 'jquery';

@Component({
  selector: 'app-cb-naver',
  templateUrl: './cb-naver.component.html',
  styleUrls: ['./cb-naver.component.scss']
})
export class CbNaverComponent implements OnInit {

  naverLoginInstance: any;

  constructor() {
    (window as any).naverSignInCallback = this.naverSignInCallback.bind(this);
    (window as any).$ = $;
  }

  ngOnInit(): void {
    this.naverLoginInstance = new naver_id_login(
      environment.naverClientId,
      environment.naverCallbackUrl
    );

    const client_id = this.naverLoginInstance.client_id;

    const state = this.naverLoginInstance.state;  // 로그인 시 넣어주는 값. callback 처리를 구분하기위함. 사용하지 않음.

    this.naverLoginInstance.get_naver_userprofile("naverSignInCallback()");

  }

  naverSignInCallback(response: any) {
    const id = this.naverLoginInstance.getProfileData('id');
    // const nickname = this.naverLoginInstance.getProfileData('nickname');

    console.log('Called from global scope!', response, id);

    const message = {
      naverKey: id,
      sign: NAVER_CALLBACK_SIGN,
    };
    window.opener.postMessage(message, window.location.origin);

    window.close();
  }
}
